import { Box, Flex } from "@otrium/core";
import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";
import { OutsideClickableBox } from "src/atoms/OutsideClickableBox";

const FiltersWrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-left: -${({ theme }) => theme.space[1]}px;
  margin-top: -${({ theme }) => theme.space[1]}px;
  > div {
    margin: ${({ theme }) => theme.space[1]}px;
  }
`;

const OutsideClickableWrapper = styled(OutsideClickableBox)`
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.space[3]}px;
  padding-bottom: ${({ theme }) => theme.space[3]}px;
  max-height: inherit;
`;

// NOTE: We need to have here position: relative; because Google Chrome hides inner content of this component
// https://stackoverflow.com/questions/22898335/strange-behavior-of-overflow-auto-on-chrome
const ScrollWrapper = styled(Box)`
  position: relative;
  overflow: auto;
  margin-bottom: ${({ theme }) => theme.space[3]}px;
  max-height: inherit;
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.tone.marble};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }
`;

const FilterContentWrapper = styled(Box)<{
  isMultiColumn?: boolean;
  count?: number;
}>`
  display: grid;
  gap: ${({ theme }) => theme.space.space8};
  ${({ isMultiColumn, count }) =>
    isMultiColumn &&
    `
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  grid-template-rows: repeat(${count || 1}, auto);
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    row-gap: ${({ theme }) => theme.space.space24};

    > div > div > label {
      display: flex;
      flex-direction: row;
    }
  }
`;

const ResultsButton = styled(Button)`
  height: 40px;
  line-height: 1;
`;

export {
  FiltersWrapper,
  OutsideClickableWrapper,
  FilterContentWrapper,
  ResultsButton,
  ScrollWrapper,
};
